<template>
  <div>
    <el-row>
      <el-col :span="8" class="cs-aeInfo-label">
        <span>占位课数：</span>
      </el-col>
      <el-col :span="8">
        <span>{{dataIn.enrollmentCount}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" class="cs-aeInfo-label">
        <span>占位价格：</span>
      </el-col>
      <el-col :span="8">
        <span>{{dataIn.aeTotalPrice|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="dataIn.memberCardModel.hasBuyMemberCard">
      <el-col :span="8" class="cs-aeInfo-label">
        <span >购买会员:</span>
      </el-col>
      <el-col :span="16">
        <span>{{dataIn.memberCardModel.memberCardDiscountPrice|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="dataIn.discountList.length > 0">
      <el-col :span="8" class="cs-aeInfo-label">
        <span >优惠类型：</span>
      </el-col>
      <el-col :span="16">
        <el-row v-for="(item, index) in dataIn.discountList" :key="index">
          <el-col :span="12">
            <span>{{item.labelName}}</span>
          </el-col>
          <el-col :span="12">
            <span>{{(-1 * item.discount)|toCurrency}}</span>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" class="cs-aeInfo-label">
        <span >总计：</span>
      </el-col>
      <el-col :span="8">
        <span>{{totalPrice|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-show="!!dataIn.balance" class="cs-redLabel">
      <el-col :span="8" class="cs-aeInfo-label">
        <span>使用余额：</span>
      </el-col>
      <el-col :span="8">
        <span>{{(-1 * dataIn.balance)|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-show="!!dataIn.bonusPointAmount" class="cs-redLabel">
      <el-col :span="8" class="cs-aeInfo-label">
        <span>使用积分：</span>
      </el-col>
      <el-col :span="8">
        <span style="float: left;">{{(-1 * dataIn.bonusPointAmount)|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-show="!!dataIn.totalPayment" class="cs-redLabel">
      <el-col :span="8" class="cs-aeInfo-label">
        <span>已付金额：</span>
      </el-col>
      <el-col :span="8">
        <span>{{(-1 * dataIn.totalPayment)|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row v-if="!!excessPrice">
      <el-col :span="8" class="cs-aeInfo-label">
        <span>超出金额：</span>
      </el-col>
      <el-col :span="8">
        <span>{{excessPrice|toCurrency}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8" class="cs-aeInfo-label">
        <span>应付价格：</span>
      </el-col>
      <el-col :span="8">
        <span>{{paymentPrice|toCurrency}}</span>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-aeInfo-label{
  min-width: 100px;
}
</style>

<script>
import global_ from "@/core/global";
import { getFormulaListByType } from "../../../service/finance.service";
import { createWorkflowModel } from "../../../service/enrollmentFee.service";

export default {
  props: {
    dataIn: {
      enrollmentCount:Number,
      aeTotalPrice:Number,
      aeDiscountPrice: Number,
      memberCardModel:{
        hasBuyMemberCard:Boolean,
        memberCardDiscountPrice:Number,
      },
      memberCardPrice:Number,
      balance: Number,
      bonusPointAmount: Number,
      accountAmount:Number,
      totalPayment:Number,
      discountList:Array
    }
  },
  data() {
    return {
      formulaModels: [],
      calculateResultViewModels: [],
    };
  },
  components: {},
  created() {

  },
  methods: {},
  computed: {
    totalPrice: function() {
      let result = this.dataIn.aeDiscountPrice;
      if (this.dataIn.memberCardModel.hasBuyMemberCard){
        result += this.dataIn.memberCardModel.memberCardDiscountPrice;
      }
      return result;
    },
    excessPrice: function() {
      let result = 0;
      if (this.dataIn.totalPayment > this.dataIn.accountAmount)
        result = this.dataIn.totalPayment - this.dataIn.accountAmount;

      return result;
    },
    paymentPrice: function() {
      let result =
        this.dataIn.accountAmount + this.excessPrice - this.dataIn.totalPayment;

      return result;
    }
  },
  methods: {
    
  },
  watch: {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/advanceEnrollmentFee/aefWorkflowInfo.vue